import React, { useMemo } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const ITALY = { lat: 42.5, lng: 12.5 };
const pinIcon = L.divIcon({
  className: '',
  html: '<div style="width:28px;height:28px;border-radius:50% 50% 50% 0;background:hsl(var(--primary));transform:rotate(-45deg);border:3px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.35)"></div>',
  iconSize: [28, 28],
  iconAnchor: [14, 28],
});

export const directionsUrl = ({ lat, lng }) => {
  const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  return ios ? `https://maps.apple.com/?daddr=${lat},${lng}` : `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
};

const ClickHandler = ({ onClick }) => { useMapEvents({ click: onClick }); return null; };

// Read-only map opens navigation on click; editable map has a draggable pin.
export const ActivityMap = ({ location, editable = false, onMove, height = 220, testid = 'activity-map' }) => {
  const center = location || ITALY;
  const open = () => location && window.open(directionsUrl(location), '_blank', 'noopener');
  const handlers = useMemo(() => ({ dragend: (e) => { const p = e.target.getLatLng(); onMove?.({ lat: p.lat, lng: p.lng }); } }), [onMove]);
  return (
    <div className="rounded-xl overflow-hidden border border-border relative z-0" style={{ height }} data-testid={testid}>
      <MapContainer center={[center.lat, center.lng]} zoom={location ? 16 : 5} scrollWheelZoom={editable} dragging={editable || !L.Browser.mobile}
        style={{ height: '100%', width: '100%', cursor: editable ? 'grab' : 'pointer' }} attributionControl>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' />
        <Marker position={[center.lat, center.lng]} icon={pinIcon} draggable={editable} eventHandlers={editable ? handlers : { click: open }} />
        {!editable && <ClickHandler onClick={open} />}
      </MapContainer>
    </div>
  );
};
